var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',[_vm._v("SEDES")]),_c('CRUDIndex',{attrs:{"permissionRoot":'Sedes',"headers":_vm.headers,"storeModel":_vm.storeModel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }